import template from "./items.html";
import controller from "./items.controller";
import "./items.scss";

let branchManagementItemsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementItemsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/items.component.js